import {getDateSlash} from "../../../utility/DateUtils";
import Loading from "../Loading";
import Random from "../Random";
import React, {useState} from "react";

const Body = ({items, indexResult, isDraw}) => {
  const [num, setNum] = useState(null)

  const onMouseEnter = (value) => {
    setNum(value)
  }

  const onMouseLeave = () => {
    setNum(null)
  }

  return (
    <table width="100%" cellSpacing="0" cellPadding="0">
      <tbody>
        <tr>
          <td valign="top" width="100%">
            <table
              cellPadding="0"
              cellSpacing="0"
              className="bkqtinhmienbac"
              width="100%"
            >
              <tbody>
                <tr onMouseEnter={() => onMouseEnter(0)} onMouseLeave={onMouseLeave}>
                  <td className={`thu ${num === 0 ? "bg-result" : ""}`} width="65">
                    <a className="f-arial" href="/" title="Click xem tất cả KQXS Miền Trung ngày">
                      {items.dayOfWeek}
                    </a>
                  </td>
                  <td className={`ngay ${num === 0 ? "bg-result" : ""}`}>
                    {
                        !isDraw && <span className="tngay">
                        Ngày: <a href="/" title={`Click xem KQXS 3 Miền Ngày: ${getDateSlash(items.drawAt)}`}>{getDateSlash(items.drawAt)}</a>
                      </span>
                    }
                    <div className="phathanh">
                      <div className="loai_ves">
                        <div className="loaive_content">
                          {" "}
                          {items.title.map((item, i) => {
                            const renderTitle = () => {
                              if (item === "***") {
                                return (
                                  <Loading
                                    sizeDigit={3}
                                    className="random-title"
                                  />
                                );
                              } else if (item === "???") {
                                return (
                                  <span>
                                    <Random sizeDigit={3} className="runLoto" />
                                  </span>
                                );
                              } else return <span key={i}>{item}</span>;
                            };
                            return (
                              <span key={i}>
                                <span>{renderTitle()}</span>
                                {items.title.length !== i + 1 && "- "}
                              </span>
                            );
                          })}
                        </div>
                        <div
                          className="loai_ve"
                          style={{
                            marginRight: "10px",
                            fontStyle: "normal",
                            fontWeight: "normal",
                          }}
                        >
                          <a href="/">
                            <span style={{ color: "#000" }}>Ký hiệu trúng Đặc Biệt:{" "}</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>

                {items &&
                  items.results.map((result, index) => (
                    <tr
                      key={index}
                      className={`${index % 2 === 0 ? "no-bg" : "bg-number"}`}
                    >
                      <td className="header" onMouseEnter={() => onMouseEnter(index + 1)} onMouseLeave={onMouseLeave}>{result.code}</td>
                      <td className={ num === (index + 1) ? "bg-result" : ""} key={index}>
                        <div className={`d-flex-round post-night-${index}`}>
                          {result.items.map((list, i) => {
                            return (
                              <div className="w-100" key={i}>
                                {list.map((e, k) => {
                                  if (e.includes("*")) {
                                    return (
                                      <div key={k}>
                                        <Loading
                                          sizeDigit={e.length}
                                          className="loading-night"
                                        />
                                      </div>
                                    );
                                  }
                                  if (e.includes("?")) {
                                    return (
                                      <div key={k}>
                                        <Random
                                          sizeDigit={e.length}
                                          className="runLoto"
                                        />
                                      </div>
                                    );
                                  }
                                  return (
                                    <div
                                      key={k}
                                      className={`key-${k} pop-able-number-${indexResult}`}
                                      data-num={e}
                                    >
                                      {e}
                                    </div>
                                  );
                                })}
                              </div>
                            );
                          })}
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default Body;
